import { Book, Order } from '@apis/index'
import BackNavigation from '@components/backNavigation'
import Button from '@components/button'
import PopupToast from '@components/custom-toast'
import useWindowSize from '@hooks/useWindow'
import { Actions, store } from '@store/index'
import { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { useNavigate, useParams } from 'react-router-dom'
import Books from '../home/Books'
import BookDescriptionLoader from '../home/loader/bookDescriptionLoader'
import {
  AuthorName,
  BookCategory,
  BookContent,
  BookDescriptionTitle,
  BookDetails,
  BookTitle,
  Description,
  FormWrapper,
  StyleFixedButton,
} from './style'
import ImageGallery from '@components/image/imgaeGallery'

const BookDesc = () => {
  const [alreadyToast, setAlreadyToast] = useState(false)
  const [moreBookToast, setMoreBookToast] = useState(false)
  const { width } = useWindowSize()
  const { id } = useParams()
  const navigate = useNavigate()
  const [loading, setLoading] = useState(false)
  const [isToastOpen, setIsToastOpen] = useState(false)
  const { data: user } = useSelector((state: any) => state.user)

  const fetchBook = async () => {
    try {
      await Book.getBook(id)
    } catch (error) {
      console.error('Error fetching book:', error)
    }
  }
  const { data: book, loading: fetching } = useSelector(
    (state: any) => state.book,
  )
  useEffect(() => {
    fetchBook()
    return () => {
      store.dispatch(Actions.reset('book'))
    }
  }, [id])

  const mobile = width < 1024

  const requestToBorrow = async (id: number) => {
    setLoading(true)
    await Order.create({
      bookId: id,
    })
      .then((resp) => {
        navigate('/books/history', { state: { activeTab: 'Borrow' } })
        store.dispatch(
          Actions.update('book', { ...book, borrowedBy: resp.createdBy }),
        )
        store.dispatch(
          Actions.update('user', {
            ...user,
            borrowedCount: user.borrowedCount + 1,
          }),
        )
      })
      .catch(() => {})
      .finally(() => setLoading(false))
  }

  const isOwner =
    Boolean(user?.id) &&
    Boolean(book?.userCreated?.id) &&
    user.id === book.userCreated.id

  const buttonTitle = !book
    ? ''
    : isOwner
      ? 'Own Book'
      : user?.id
        ? 'Request to borrow Book'
        : 'Login to borrow Book'

  const restImages = book?.additionalImages
    ? book?.additionalImages?.map((item) => {
        return item?.images
      })
    : []

  const handleBorrow = () => {
    if (user?.borrowedCount === 2) {
      setMoreBookToast(true)
    } else if (user?.id) {
      if (book?.borrowedBy === user?.id) {
        setAlreadyToast(true)
      } else {
        setIsToastOpen(true)
      }
    } else {
      navigate('/login')
    }
  }

  const renderButton = () => {
    const isOwner = Boolean(
      user?.id && book?.userCreated?.id && user.id === book.userCreated.id,
    )

    return (
      <Button
        title={buttonTitle}
        type="button"
        disabled={isOwner}
        height={40}
        onClick={handleBorrow}
        loading={loading}
        styleButtonWrapper="margin-top:auto"
      />
    )
  }

  return (
    <>
      <BackNavigation title="Back" />
      <FormWrapper style={{ margin: '10px 0' }}>
        {!!fetching && <BookDescriptionLoader />}
        {!fetching && (
          <BookContent>
            <BookDetails>
              <ImageGallery images={[book.coverImage, ...restImages]} />
            </BookDetails>

            <BookDetails>
              <BookTitle>{book?.name}</BookTitle>
              <div style={{ display: 'flex', gap: '10px' }}>
                <BookCategory>{book?.categoryData?.name}</BookCategory>
                <AuthorName>{book?.author}</AuthorName>
              </div>
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                  gap: '10px',
                }}
              >
                <BookDescriptionTitle>Description</BookDescriptionTitle>
                <Description>{book?.description}</Description>
              </div>
              {!mobile ? (
                renderButton()
              ) : (
                <StyleFixedButton>{renderButton()}</StyleFixedButton>
              )}
            </BookDetails>
          </BookContent>
        )}
      </FormWrapper>
      {!mobile && <Books />}
      <PopupToast
        isOpen={isToastOpen}
        content="Are you sure you want to request to borrow this book?"
        onClick={() => requestToBorrow(book?.id)}
        onClose={() => setIsToastOpen(false)}
        imageLink={`${process.env.BUCKET_URL}/${book?.coverImage}`}
        buttonText="Yes"
        cancelText={'No'}
        tag={book?.name}
      />
      <PopupToast
        isOpen={alreadyToast}
        bookToast
        content={
          book?.borrowedBy === user?.id
            ? 'You have already borrowed Book Titled'
            : 'Some have already borrowed Book Titled'
        }
        secondary="Browse other books"
        onClick={() => {
          setAlreadyToast(false)
        }}
        image="alreadyBorrowed"
        buttonText="Ok"
        tag={book?.name}
      />
      <PopupToast
        isOpen={moreBookToast}
        bookToast
        secondary="To borrow a new book, return one of your previously borrowed books."
        content="Sorry, You are allowed to borrow only 2 books at a time."
        onClick={() => {
          setMoreBookToast(false)
        }}
        image="moreBook"
        buttonText="Ok"
      />
    </>
  )
}

export default BookDesc
